import SectionWelcome from './SectionWelcome'

export default SectionWelcome
